import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={25.989}
    height={20.921}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 19142 15409"
    {...props}
  >
    <defs>
      <style>
        {
          // ".str0,.str1{stroke:#fefefe;stroke-width:212.127}.str1{stroke:#000;stroke-linecap:round;stroke-linejoin:round}.fil0{fill:#000}"
        }
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2528313077104">
        <path
          d="M2823 1779v-8c-7-14-7-36-15-51 0-7-7-7-7-15-7-14-15-21-22-36 0-7-7-7-7-15 0 0 0-7-7-7L1720 237c-58-80-153-131-256-131s-197 44-256 131L171 1647s0 7-7 7c0 7-7 7-7 15-7 15-15 22-22 37 0 7-7 7-7 15-8 14-15 36-15 50v7c0 15-7 29-7 51v13160c0 176 139 314 314 314h2082c174 0 328-139 328-314V1830c0-15 0-29-7-51zM1472 953l417 563h-834l417-563zm723 13715H749V2144h1446v12524z"
          className="fill stroke1"
          style={{
            strokeWidth: 212.127,
          }}
        />
        <path
          d="M9496 14632H2507c-36 0-65-29-65-65V3393c0-37 29-65 65-65h2047c13 0 25 3 35 10 1460 952 3158 1456 4907 1456 36 0 65 29 65 65v9708c0 36-29 65-65 65h0zm-6924-131h6859V4923c-1746-12-3437-518-4897-1465H2572v11043z"
          className="fill stroke1"
          style={{
            strokeWidth: 212.127,
            strokeLinecap: "round",
            strokeLinejoin: "round",
          }}
        />
        <path
          d="M16485 14632H9496c-36 0-65-29-65-65V4859c0-36 29-65 65-65 1750 0 3447-504 4907-1456 11-7 23-10 35-10h2047c36 0 65 28 65 65v11174c0 36-29 65-65 65h0zm-6924-131h6859V3458h-1962c-1460 948-3151 1453-4897 1466v9577zM4042 12601c-36 0-65-29-65-65V6945c0-36 29-65 65-65 37 0 66 29 66 65v5591c0 36-29 65-66 65zM5370 12601c-36 0-65-29-65-65V6945c0-36 29-65 65-65s65 29 65 65v5591c0 36-29 65-65 65zM6697 12601c-36 0-65-29-65-65V6945c0-36 29-65 65-65 37 0 65 29 65 65v5591c0 36-28 65-65 65zM8025 12601c-36 0-65-29-65-65V6945c0-36 29-65 65-65s65 29 65 65v5591c0 36-29 65-65 65z"
          className="fill stroke1"
          style={{
            strokeWidth: 212.127,
            strokeLinecap: "round",
            strokeLinejoin: "round",
          }}
        />
        <path
          d="M11104 12601c-36 0-65-29-65-65V6945c0-36 29-65 65-65s65 29 65 65v5591c0 36-29 65-65 65zM12431 12601c-36 0-65-29-65-65V6945c0-36 29-65 65-65s65 29 65 65v5591c0 36-29 65-65 65zM13759 12601c-36 0-65-29-65-65V6945c0-36 29-65 65-65s65 29 65 65v5591c0 36-29 65-65 65zM15086 12601c-36 0-65-29-65-65V6945c0-36 29-65 65-65 37 0 66 29 66 65v5591c0 36-29 65-66 65z"
          className="fill stroke1"
          style={{
            strokeWidth: 212.127,
            strokeLinecap: "round",
            strokeLinejoin: "round",
          }}
        />
      </g>
      <g id="_2528313084912">
        <path
          d="M16319 1779v-8c7-14 7-36 15-51 0-7 7-7 7-14 7-15 15-22 22-37 0-7 7-7 7-14 0 0 0-8 7-8l1045-1410c58-79 153-130 256-130s197 44 256 130l1037 1410s0 8 7 8c0 7 7 7 7 14 7 15 15 22 22 37 0 7 7 7 7 15 8 14 15 36 15 50v8c0 14 7 29 7 51v13159c0 176-139 314-314 314h-2081c-175 0-329-139-329-314V1830c0-15 0-29 7-51zm1351-825-416 562h833l-417-562zm-723 13715h1447V2144h-1447v12525z"
          className="fill stroke1"
          style={{
            strokeWidth: 212.127,
          }}
        />
        <path
          d="M9646 14632h6989c36 0 65-29 65-65V3393c0-36-29-65-65-65h-2047c-12 0-25 4-35 10-1460 953-3157 1457-4907 1457-36 0-65 29-65 65v9707c0 36 29 65 65 65h0zm6924-130H9711V4924c1746-12 3438-519 4897-1466h1962v11044z"
          className="fill stroke1"
          style={{
            strokeWidth: 212.127,
            strokeLinecap: "round",
            strokeLinejoin: "round",
          }}
        />
        <path
          d="M2657 14632h6989c36 0 65-29 65-65V4860c0-36-29-65-65-65-1750 0-3447-504-4907-1457-11-7-23-10-35-10H2657c-36 0-65 29-65 65v11174c0 36 29 65 65 65h0zm6924-130H2722V3458h1962c1460 948 3151 1454 4897 1467v9577zM15100 12602c36 0 65-29 65-65V6946c0-36-29-65-65-65s-65 29-65 65v5591c0 36 29 65 65 65zM13772 12602c36 0 65-29 65-65V6946c0-36-29-65-65-65s-65 29-65 65v5591c0 36 29 65 65 65zM12445 12602c36 0 65-29 65-65V6946c0-36-29-65-65-65s-65 29-65 65v5591c0 36 29 65 65 65zM11117 12602c36 0 65-29 65-65V6946c0-36-29-65-65-65s-65 29-65 65v5591c0 36 29 65 65 65z"
          className="fill stroke1"
          style={{
            strokeWidth: 212.127,
            strokeLinecap: "round",
            strokeLinejoin: "round",
          }}
        />
        <path
          d="M8038 12602c36 0 65-29 65-65V6946c0-36-29-65-65-65s-65 29-65 65v5591c0 36 29 65 65 65zM6711 12602c36 0 65-29 65-65V6946c0-36-29-65-65-65s-65 29-65 65v5591c0 36 29 65 65 65zM5383 12602c36 0 65-29 65-65V6946c0-36-29-65-65-65s-65 29-65 65v5591c0 36 29 65 65 65zM4056 12602c36 0 65-29 65-65V6946c0-36-29-65-65-65s-65 29-65 65v5591c0 36 29 65 65 65z"
          className="fill stroke1"
          style={{
            strokeWidth: 212.127,
            strokeLinecap: "round",
            strokeLinejoin: "round",
          }}
        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
